import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormService } from 'src/app/form/form.service';
import { SharedService } from 'src/app/services/shared.service';
import { CloneTemplateComponent } from '../clone-template/clone-template.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-clone-template-organization',
  templateUrl: './clone-template-organization.component.html',
  styleUrls: ['./clone-template-organization.component.scss']
})
export class CloneTemplateOrganizationComponent implements OnInit {

  organizations: Array<any> = [];
  @ViewChild("organizationRef") organizationRef: TemplateRef<any>;
  confirmationDialog: MatDialogRef<any>;

  constructor(
    public dialogRef: MatDialogRef<CloneTemplateOrganizationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any = {},
    private _formService: FormService,
    private _sharedService: SharedService,
    public dialog: MatDialog,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this.organizations = this.data['organizations'];
    let sourceOrganization = this.data['source'];
    this.organizations = _.filter(this.organizations, (org) => org._id != sourceOrganization._id);
  }

  onClose() {
    this.dialogRef.close();
  }

  onOrganizationClick(organization: any) {
    this.confirmationDialog = this.dialog.open(this.organizationRef, {
      data: {
        form: this.data.form,
        organization: organization.name
      }
    })
    this.confirmationDialog.afterClosed().subscribe((dialogResponse: any) => {
      this._formService.cloneTemplateToOtherOrg(this.data.form._id, organization._id).subscribe((response: any) => {
        if(response['success']) {
          this.onClose();
          this._sharedService.openSnackBar("Form cloned successfully.");
          if(dialogResponse && dialogResponse['edit']) {
            this._router.navigateByUrl(`form-builder?id=${response['template']}`);
          }
        }
      }, (error) => {
        if(error?.error?.message) {
          return this._sharedService.openSnackBar(error.error.message);
        }
        this._sharedService.openSnackBar("Form cloning failed.")
      })
    })
  }

  onClosingConfirmation(data?: any) {
    this.confirmationDialog.close(data);
  }

}
